import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import SupplyChainExcellence from "./sections/SupplyChainExcellence";
import OurProfessionalCraftsmanship from "./sections/OurProfessionalCraftsmanship";
import TheCraigsGuarantee from "./sections/TheCraigsGuarantee";
import TheVisualJournal from "./sections/TheVisualJournal";
import ClientPraise from "./sections/ClientPraise";
import ConnectWithOurExperts from "./sections/ConnectWithOurExperts";
import ServiceAreaMap from "./sections/ServiceAreaMap";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <SupplyChainExcellence />
      <OurProfessionalCraftsmanship />
      <TheCraigsGuarantee />
      <TheVisualJournal />
      <ClientPraise />
      <ConnectWithOurExperts />
      <ServiceAreaMap />
      <Footer />
    </div>;
}